/**
 * [API Docs] https://api.platform.cresclab.com/api/docs#tag/MCP
 *
 * The keys Crescendo Lab MCP issues when someone connects an AI client.
 * Interlude lists and revokes them on their own router, so neither this page
 * nor the API key page can reach the other's keys.
 *
 * There is deliberately no create or update here: an MCP key is only ever
 * minted by the MCP server's OAuth flow.
 */
import { makeApi } from "@zodios/core";
import { z } from "zod";

import { McpApiKeySchema } from "../models";

const api = makeApi([
  {
    alias: "listMcpApiKeys",
    method: "get",
    path: "/api/v1/mcp/api-keys/",
    /** Wrapped in `data`, not a bare array. */
    response: z.object({
      data: z.array(McpApiKeySchema),
    }),
  },
  {
    alias: "deleteMcpApiKey",
    method: "delete",
    path: "/api/v1/mcp/api-keys/:credentialId/",
    parameters: [
      {
        type: "Path",
        name: "credentialId",
        schema: McpApiKeySchema.shape.id,
      },
    ],
    // 204 No Content with z.void() or z.never() not working here
    response: z.unknown(),
  },
]);

export { api };
